unable to read source [project]/node_modules/src/state-manager.ts